import { render } from "./PageFormInformasiKeluarga.vue?vue&type=template&id=935c1478"
import script from "./PageFormInformasiKeluarga.vue?vue&type=script&lang=js"
export * from "./PageFormInformasiKeluarga.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__